import { Button, Modal } from "antd"
import { TimePattern2 } from "../../../../common/timePattern/TimePattern2"
import * as React from "react"
import { CSSProperties } from "react"
import { TimeSpan } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/hours_of_operation_v2"

type DeliveryModalProps = {
    deliveryHoo: TimeSpan[]
    deliveryHooModalOpen: boolean
    deliveryHooActive: boolean
    onDoneClicked: () => void
    onChange: (value: TimeSpan[]) => void
}
export const DeliveryHooModal = (props: DeliveryModalProps) => {
    return (
        <Modal
            visible={props.deliveryHooModalOpen}
            title={<span style={styles.hooModalTitle}>Delivery Hours Of Operation</span>}
            closable={false}
            maskClosable={false}
            bodyStyle={styles.hooModalBody}
            width={570}
            footer={
                <Button type="primary" style={styles.hooModalBtn} onClick={props.onDoneClicked}>
                    Done
                </Button>
            }>
            <TimePattern2 value={props.deliveryHoo} onChange={props.onChange} />
        </Modal>
    )
}

type PickupModalProps = {
    pickupHoo: TimeSpan[]
    pickupHooModalOpen: boolean
    pickupHooActive: boolean
    onDoneClicked: () => void
    onChange: (value: TimeSpan[]) => void
}

export const PickupHooModal = (props: PickupModalProps) => {
    return (
        <Modal
            visible={props.pickupHooModalOpen}
            title={<span style={styles.hooModalTitle}>Pickup Hours Of Operation</span>}
            closable={false}
            maskClosable={false}
            bodyStyle={styles.hooModalBody}
            width={570}
            footer={
                <Button type="primary" style={styles.hooModalBtn} onClick={props.onDoneClicked}>
                    Done
                </Button>
            }>
            <TimePattern2 value={props.pickupHoo} onChange={props.onChange} />
        </Modal>
    )
}

const styles: Record<string, CSSProperties> = {
    hooModalTitle: {
        fontWeight: "bold",
    },
    hooModalBtn: {
        marginRight: "0.5rem",
    },
    hooModalBody: {
        paddingBottom: "0.25rem",
    },
}
